/**
 * Файлы из `apps/lk/public/` отдаются как статика с корня сайта (URL начинается с `/`).
 * Удобно для крупных/часто меняющихся SVG, фонов, когда не нужен React-компонент.
 *
 * SVG из `src/` (например `src/shared/assets/svg/`):
 * — как **React-компонент** (SVGR): суффикс `?react`;
 * — как **URL строки** (как у `public`): без суффикса.
 *
 * @example React-компонент
 * import Icon from 'shared/assets/svg/icon.svg?react';
 * <Icon className="h-6 w-6" aria-hidden />
 *
 * @example URL для img / background-image
 * import iconUrl from 'shared/assets/svg/icon.svg';
 * <img src={iconUrl} alt="" />
 */

/** Путь относительно корня `public/` (без ведущего слеша). */
export function publicAsset(relativePath: string): string {
	const trimmed = relativePath.replace(/^\/+/, '');
	return `/${trimmed}`;
}

/** Частые пути под `public/assets/img/`. */
export const lkPublicImg = {
	orderCardBackground: (index: number) => publicAsset(`assets/img/background/${index}.svg`),
	app: (appFolder: string, file: string) => publicAsset(`assets/img/${appFolder}/${file}`),
} as const;
